export class Affected {
    get id() {
        return this.affectedState.id;
    }
    get diligenceNumber() {
        return this.affectedState.diligenceNumber;
    }
    get affectedThird() {
        return this.affectedState.affectedThird;
    }
    get manifestation() {
        return this.affectedState.manifestation;
    }
    get date() {
        return this.affectedState.date;
    }
    get presents() {
        return this.affectedState.presents;
    }
    get userId() {
        return this.affectedState.userId;
    }
    get third_name() {
        return this.affectedState.third_name;
    }
    set diligenceNumber(diligenceNumber) {
        this.affectedState.diligenceNumber = diligenceNumber;
    }
    set affectedThird(affectedThird) {
        this.affectedState.affectedThird = affectedThird;
    }
    set manifestation(manifestation) {
        this.affectedState.manifestation = manifestation;
    }
    set date(date) {
        this.affectedState.date = date;
    }
    set presents(presents) {
        this.affectedState.presents = presents;
    }
    set userId(userId) {
        this.affectedState.userId = userId;
    }
    constructor(affectedState) {
        this.affectedState = affectedState;
    }
    getState() {
        return this.affectedState;
    }
}
